import { Component } from '@angular/core';
import { IonicPage, Nav, NavController, NavParams, Events } from 'ionic-angular';

import { MyActivity,Employee, IdleStaff, Tracking, MarkerPage, TrackingWeb } from '..';
import { DashboardPage as HomeProject } from '../../project_mobile/index';
import { HomePage as HomeAdvance } from '../../advance_mobile/index';

import { Utility } from '@providers/resources/utility';

// @IonicPage()
@Component({
  selector: 'activity-tabs',
  templateUrl: 'activity.html'
})
export class AppActivity {
  tab1Root: any = Employee;
  tab2Root: any = MyActivity;
  tab3Root: any = IdleStaff;
  tab4Root: any;

  mySelectedIndex :number = 0;

  buildApk = this.utility.buildApk;

  constructor(
    public navCtrl  : NavController,
    public nav      : Nav,
    public navParams: NavParams,
    public events   : Events,
    public utility  : Utility
    ) {

    if(this.buildApk){
      this.tab4Root = Tracking;
    }else{
      this.tab4Root = TrackingWeb;
    }
      
    this.events.publish('user:check_login', false);
    this.mySelectedIndex = this.navParams['data']['tabIndex'];
  }
}



// WEBPACK FOOTER //
// ./src/pages/activity/activityApp/activity.ts